/**
* Related Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Related Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'related-services',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.related-services.splide' ).length ) {
        $( '.related-services.splide' ).each( function( index, element ) {
          new Splide( element, {
            type: 'slide',
            gap: '2rem',
            perPage: 3,
            perMove: 1,
            pagination: false,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } ).mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'related-services', COMPONENT );
} )( app );
